import { render, staticRenderFns } from "./MapPopupIcon.vue?vue&type=template&id=75452d97&"
import script from "./MapPopupIcon.vue?vue&type=script&lang=js&"
export * from "./MapPopupIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports